import React, { Component } from "react";

import { valueStrings } from "constants/constantStrings";

import DupontIconButton from "components/DupontIconButton";

import DeleteTableIcon from "assets/SvgIcon/Table/DeleteTableIcon";

export default class TagDeleteRenderer extends Component {
  constructor(props) {
    super(props);
    this.invokeParentMethod = this.invokeParentMethod.bind(this);
  }

  invokeParentMethod() {
    this.props.context.handleDeleteClick(this.props.node.data);
  }

  render() {
    const isDeletable = this.props.data?.IsDeletable;
    return (
      <DupontIconButton tooltip={valueStrings.delete} onClick={this.invokeParentMethod} disabled={!isDeletable}>
        <DeleteTableIcon disabled={!isDeletable} />
      </DupontIconButton>
    );
  }
}
